export const FixingMode = {
  VALORISATION: "valorisation", // typiquement un bijou => pas de quantité + market-value dans time_series
  FIXING: "fixing", // typiquement une action => aura une quantité + unit-price dans time_series
  NA: "NA", // ni price, ni market-value ni quantity
} as const;

export type FixingMode = (typeof FixingMode)[keyof typeof FixingMode]; // Union Type
